export * from '../src/composites/wui-avatar/index.js';
//# sourceMappingURL=wui-avatar.js.map